import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { IonDatetime } from '@ionic/angular';
import * as moment from 'moment';

@Component({
  selector: 'app-calendar-input',
  templateUrl: './calendar-input.component.html',
  styleUrls: ['./calendar-input.component.scss'],
})
export class CalendarInputComponent implements OnInit {
  @Input() control: FormControl;
  @Input() maxDate: string;
  @ViewChild('datePicker', { static: false }) datePicker: IonDatetime;

  constructor() {}

  ngOnInit() {
    if (!this.maxDate) {
      this.maxDate = new Date(new Date().setFullYear(new Date().getFullYear() + 10)).toISOString();
    }
  }

  formatDateInput(event: any) {
    const input = event.target.value;
    const parsedDate = moment(input, 'DD/MM/YYYY', true);
    if (parsedDate.isValid()) {
      this.control.setValue(parsedDate.format('DD/MM/YYYY'));
    }
  }

  onDateChange(event: any) {
    const date = event.detail.value;
    if (date) {
      const formattedDate = moment(date).format('DD/MM/YYYY');
      this.control.setValue(formattedDate);
    }
  }
}
